import { SortModelItem } from 'ag-grid-community';

export const SEMEN_SORT_FIELD_MAPPINGS: Record<string, string> = {
  ownerName: 'owner.name',
  ownerCode: 'owner.code',
  shipmentName: 'shipment.shipName',
  shipmentNumber: 'shipment.shipmentNumber',
  quantityReceived: 'quantityRec',
  semenLocationSite: 'storageLocation.site.name',
  createdBy: 'createdBy.fullName',
  modifiedBy: 'modifiedBy.fullName',
};

export const mapSemenSortModel = (
  sortModel: SortModelItem[],
): SortModelItem[] =>
  sortModel.map((item) => ({
    ...item,
    colId: SEMEN_SORT_FIELD_MAPPINGS[item.colId] ?? item.colId,
  }));
